module.exports = __webpack_public_path__ + "static/media/waves-min-med.43c1bc39.jpg";